import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import type { FreeShippingCountries } from './__generated__/FreeShippingCountries';
import FREE_SHIPPING_COUNTRIES_QUERY from './useFreeShipping.query';

const useFreeShipping = (countryCode: string | undefined) => {
  const { data, loading, error } = useQuery<FreeShippingCountries>(
    FREE_SHIPPING_COUNTRIES_QUERY,
  );

  const freeShippingCountries =
    data?.magento2?.storeConfig?.freeShippingCountries;

  const isFreeShipping = useMemo(
    () => Boolean(countryCode && freeShippingCountries?.includes(countryCode)),
    [freeShippingCountries, countryCode],
  );

  return {
    loading,
    error,
    isFreeShipping,
  };
};

export default useFreeShipping;
